import { inject, Injectable } from '@angular/core';
import { MemberPreferences } from '@cassiopeia/integration';
import { toISODateString } from '@nestech/utils';
import { MemberStore } from '../../member/member-store';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  #memberStore = inject(MemberStore);

  dismiss(notificationId: string) {
    this.#memberStore.patchPreferences({
      notifications: { [notificationId]: { dismissedDate: toISODateString(new Date()) } },
    });
  }

  isNotificationDismissed(preferences: MemberPreferences | undefined, notificationId: string): boolean {
    return !!preferences?.notifications?.[notificationId]?.dismissedDate;
  }
}
